import React from 'react';
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Divider,
  Grid2,
  TextField,
  Typography
} from '@mui/material';
import {styles} from '@invoice-system';
import {t} from 'ttag';
import {Controller, useForm} from 'react-hook-form';
import {Search} from '@mui/icons-material';
import {yupResolver} from '@hookform/resolvers/yup';
import * as yup from 'yup';
import {DateRangePicker} from '@components/date-range-picker';
import {DateTime} from 'luxon';
import {DATE_FORMAT} from '../../utils/datetime/datetime-utils';
import {useNavigate} from 'react-router-dom';

export const ActivitiesSearch = () => {
  const navigate = useNavigate();
  const {control, handleSubmit} = useForm({
    resolver: yupResolver(
      yup.object().shape({
        dateRange: yup.object().shape({
          startDate: yup.date().required(t`Start date is required`),
          endDate: yup.date().required(t`End date is required`)
        }),
        username: yup.string().required(t`Username is required`)
      })
    ),
    defaultValues: {
      dateRange: {
        startDate: DateTime.now().startOf('year').toJSDate(),
        endDate: DateTime.now().endOf('year').toJSDate()
      },
      username: ''
    }
  });

  const handleSubmitForm = handleSubmit(
    (data) => {
      const startDate = DateTime.fromJSDate(data.dateRange.startDate).toFormat(DATE_FORMAT);
      const endDate = DateTime.fromJSDate(data.dateRange.endDate).toFormat(DATE_FORMAT);
      navigate(`/activities/list/${data.username}/${startDate}/${endDate}`);
    },
    (error) => console.error(error)
  );

  return (
    <Card elevation={3}>
      <CardHeader
        title={<Typography sx={styles.title}>{t`Client Activities Search`}</Typography>}
        subheader={
          <Typography sx={styles.subHeader} variant={'subtitle2'}>
            {t`Search for a client's activities by username, start date, and end date.`}
          </Typography>
        }
      />
      <Divider />
      <CardContent sx={{py: 4}}>
        <Grid2 container spacing={2}>
          <Grid2 size={{xs: 12, sm: 6}}>
            <Controller
              name={'username'}
              control={control}
              defaultValue={''}
              render={({field, fieldState: {error}}) => (
                <TextField
                  {...field}
                  label={t`SATA Imagine`}
                  variant='outlined'
                  fullWidth
                  type='number'
                  error={!!error}
                  size={'small'}
                  helperText={error ? error.message : ''}
                />
              )}
            />
          </Grid2>
          <Grid2 size={{xs: 12, sm: 6}}>
            <Controller
              name={'dateRange'}
              control={control}
              render={({field, fieldState: {error}}) => (
                <DateRangePicker size={'small'} range={field.value} onChange={field.onChange} />
              )}
            />
          </Grid2>
        </Grid2>
      </CardContent>
      <Divider />
      <CardActions sx={styles.actions}>
        <Button variant='contained' color='primary' startIcon={<Search />} onClick={handleSubmitForm}>
          {t`Search Activities`}
        </Button>
      </CardActions>
    </Card>
  );
};

export default ActivitiesSearch;
